import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  IconButton,
} from "@mui/material";
import { PageBar } from "../../../CommonComponents";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import RaisedRequests from "../Track_Requests/Raised_Requests";
import styled from "styled-components";
import DatePicker from "react-datepicker";
import Box_Modal from "./Box_Modal";
import CreateModal from "./create_modal";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import Cookies from "js-cookie";
import { GMB } from "../../../services/gmbApiConfig";
import { toast } from "react-toastify";

const StyledDatePicker = styled(DatePicker)`
  width: 250px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  font-size: 14px;
  color: #333;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
`;

const Index = () => {
  const getCurrentDate = () => {
    return new Date();
  };

  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState("Last 7 days");
  const currentDate = getCurrentDate();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [create, setCreate] = useState(false);
  const [tabledata, setTabledata] = useState(null);
  const [originalData, setOriginalData] = useState(null);
  const [dropdowndata, setDropdowndata] = useState([]);
  const [projectname, setProjectname] = useState("");
  const [issuetype, setIssuetype] = useState("");
  const [requestedby, setRequestedby] = useState("");
  const [status, setStatus] = useState("");
 

  const handleChangeProject = (event) => {
    setProjectname(event.target.value);
  };
  const handleChangeIssue = (event) => {
    setIssuetype(event.target.value);
  };
  const handleRequestedBy = (event) => {
    setRequestedby(event.target.value);
  };

  const getMonthName = (date) => {
    const months = [
      "Jan",
      "Feb",
      "March",
      "April",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months[date.getMonth()];
  };
  const today = currentDate;
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = getMonthName(date);
    const day = ("0" + date.getDate()).slice(-2);
    return `${month},${day} ${year}`;
  };

  const handleStartDateChange = (date) => {
    setStartDate(
      date
        ? new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)
        : null
    );
  };

  const handleEndDateChange = (date) => {
    setEndDate(
      date
        ? new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            23,
            59,
            59
          )
        : null
    );
  };

  const fetchDropdownData = async () => {
    try {
      const response = await axios.post(
        `https://cqslmlqa6kdef2jyswlz5vtl4y0eoova.lambda-url.ap-south-1.on.aws/get_create_project_dropdowns`,
        { domain_id: Cookies.get("ssp_domain_id") },
        {
          headers: {
            Authorization: Cookies.get("ssp_sso_token"),
            "content-type": "application/json",
          },
        }
      );
      if (response.data?.status === "error") {
        toast.error("Failed to fetch store accounts");
      }
      setDropdowndata(response?.data?.data);
    } catch (error) {
      toast.error("Failed to fetch store accounts");
    }
  };

  const fetchTableData = async () => {
    try {
      const response = await axios.post(
        `https://cqslmlqa6kdef2jyswlz5vtl4y0eoova.lambda-url.ap-south-1.on.aws/get_all_tasks`,
        {
          project: projectname ? projectname : "",
          issue_type: issuetype ? issuetype : "",
          requested_by: requestedby ? requestedby : "",
          status: "",
          role: parseInt(Cookies.get("ssp_role"),10),
          domain_id: Cookies.get("ssp_domain_id")
        },
        {
          headers: {
            Authorization: Cookies.get("ssp_sso_token"),
            "content-type": "application/json",
          },
        }
      );
      if (response?.data?.body) {
        setOriginalData(response?.data?.body);
        setTabledata(response?.data?.body);
      } else if (response?.data?.message) {
        setOriginalData([]);
        setTabledata([]);
      }
    } catch (error) {
      toast.error("Failed to load Data");
    }
  };

  useEffect(() => {
    fetchTableData();
    fetchDropdownData();
    handleFilterData();
  }, []);

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    const currentDate = new Date();
    const yesterdayDate = new Date(
      currentDate.getTime() - 1 * 24 * 60 * 60 * 1000
    );

    if (event.target.value === "Today") {
      setStartDate(currentDate);
      setEndDate(currentDate);
    } else if (event.target.value === "Yesterday") {
      setStartDate(yesterdayDate);
      setEndDate(yesterdayDate);
    } else if (event.target.value === "This Month") {
      setStartDate(
        new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)
      );
      setEndDate(
        new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0)
      );
    } else if (event.target.value === "Last Month") {
      const lastMonthStart = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - 1,
        1
      );
      const lastMonthEnd = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        0
      );
      setStartDate(lastMonthStart);
      setEndDate(lastMonthEnd);
    } else if (event.target.value === "Last 7 days") {
      setStartDate(new Date(currentDate.getTime() - 6 * 24 * 60 * 60 * 1000));
      setEndDate(currentDate);
    } else if (event.target.value === "Last 30 days") {
      setStartDate(new Date(currentDate.getTime() - 29 * 24 * 60 * 60 * 1000));
      setEndDate(currentDate);
    } else if (event.target.value === "Custom") {
      setStartDate(null);
      setEndDate(null);
    }
  };

  const handleFilterData = () => {
    if (originalData && originalData.length > 0) {
      let filtered = [...originalData]; 
      if (startDate && endDate) {
        filtered = filtered.filter(item => {
          const createDate = new Date(item.create_date);
          return createDate >= startDate && createDate <= endDate;
        });
      }
      if (projectname) {
        filtered = filtered.filter(item => item.project === projectname);
      }
      if(issuetype){
        filtered = filtered.filter(item => item.issue_type === issuetype);
      }
      if (status) {
        filtered = filtered.filter(item => item.status === status);
      }
      if (requestedby) {
        filtered = filtered.filter(item => item.uat_by === requestedby);
      }
      setTabledata(filtered);
    }
  };
  

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#EEF2F7",
        }}
      >
        <PageBar text="Create new request" />
        <Button
          style={{
            backgroundColor: "#0160F1",
            color: "white",
            fontSize: "0.875rem",
            borderRadius: "0.35rem",
            marginLeft: "3rem",
            marginTop: "1.5rem",
            paddingLeft: "1rem",
            paddingRight: "1rem",
            padding: "0.5rem 1.125rem",
          }}
          onClick={() => {
            setCreate(true);
          }}
        >
          Create
        </Button>
        {create && (
          <Box_Modal
            open={create}
            handleOpenClose={setCreate}
            message={<CreateModal setCreate={setCreate} />}
          />
        )}
        <br />
        <Card
          sx={{
            backgroundColor: "#EEF2F7",
            padding: "1.3rem",
          }}
        >
          <CardHeader
            p={2}
            sx={{
              backgroundColor: "#F8F8F9",
              fontWeight: "700",
              borderTopRightRadius: "5px",
              borderTopLeftRadius: "5px",
            }}
            title={" Filters"}
            titleTypographyProps={{
              sx: {
                fontSize: "16px",
                fontWeight: "600",
                lineHeight: "16px",
                color: "#0160F1",
              },
            }}
          />
          <Divider />
          <CardContent
            sx={{
              backgroundColor: "#FFFFFF",
              borderBottomRightRadius: "5px",
              borderBottomLeftRadius: "5px",
              fontSize: 15,
              marginBottom: -5,
            }}
          >
            <Grid container spacing={1} alignItems="center" direction="row">
              <Grid
                item
                xs={2}
                sx={{ display: "flex", flexDirection: "column" }}
              >
                <Typography
                  sx={{
                    fontSize: 15,
                    marginBottom: "0.5rem",
                    marginLeft: "0.5rem",
                  }}
                >
                  Project
                </Typography>
                <FormControl
                  sx={{
                    maxWidth: 200,
                    minWidth: 200,
                    marginTop: 1,
                    marginBottom: 1,
                  }}
                >
                  <Select
                    displayEmpty
                    size="small"
                    sx={{ fontSize: 15, textAlign: "left" }}
                    value={projectname}
                    onChange={handleChangeProject}
                  >
                    <MenuItem value="">
                      <em>Select Project</em>
                    </MenuItem>
                    {Array.isArray(dropdowndata?.project) &&
                      dropdowndata?.project.map((option) => (
                        <MenuItem
                          key={option}
                          value={option}
                          sx={{ fontSize: 15 }}
                        >
                          {option}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                xs={2}
                sx={{ display: "flex", flexDirection: "column" }}
              >
                <Typography
                  sx={{
                    fontSize: 15,
                    marginBottom: "0.5rem",
                    marginLeft: "0.5rem",
                  }}
                >
                  Request Type
                </Typography>
                <FormControl
                  sx={{
                    maxWidth: 200,
                    minWidth: 200,
                    marginTop: 1,
                    marginBottom: 1,
                  }}
                >
                  <Select
                    displayEmpty
                    size="small"
                    sx={{ fontSize: 15, textAlign: "left" }}
                    value={issuetype}
                    onChange={handleChangeIssue}
                  >
                    <MenuItem value="">
                      <em>Select Request type</em>
                    </MenuItem>
                    {Array.isArray(dropdowndata?.issue_type) &&
                      dropdowndata?.issue_type.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                xs={2}
                sx={{ display: "flex", flexDirection: "column" }}
              >
                <Typography
                  sx={{
                    fontSize: 15,
                    marginBottom: "0.5rem",
                    marginLeft: "0.5rem",
                  }}
                >
                  Requested By
                </Typography>
                <FormControl
                  sx={{
                    maxWidth: 200,
                    minWidth: 200,
                    marginTop: 1,
                    marginBottom: 1,
                  }}
                >
                  <Select
                    displayEmpty
                    size="small"
                    sx={{ fontSize: 15, textAlign: "left" }}
                    value={requestedby}
                    onChange={handleRequestedBy}
                  >
                    <MenuItem value="">
                      <em>Select name</em>
                    </MenuItem>
                    {Array.isArray(dropdowndata?.pms) &&
                      dropdowndata?.pms.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                xs={2}
                sx={{ display: "flex", flexDirection: "column" }}
              >
                <Typography
                  sx={{
                    fontSize: 15,
                    marginBottom: "0.5rem",
                    marginLeft: "0.5rem",
                  }}
                >
                  Status
                </Typography>
                <FormControl
                  sx={{
                    maxWidth: 200,
                    minWidth: 200,
                    marginTop: 1,
                    marginBottom: 1,
                  }}
                >
                  <Select
                    displayEmpty
                    size="small"
                    sx={{ fontSize: 15, textAlign: "left" }}
                    value=""
                    // onChange={handleChangeProject}
                  >
                    <MenuItem value="">
                      <em>Select status</em>
                    </MenuItem>
                    {/* {projectOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                        {option}
                    </MenuItem>
                    ))} */}
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                xs={2}
                sx={{ display: "flex", flexDirection: "column" }}
              >
                <Typography sx={{ fontSize: 15, marginBottom: '0.5rem' }}>Creation Date</Typography>
                <Select
                  size="small"
                  value={selectedOption}
                  onChange={handleOptionChange}
                  wordwrap="break-word"
                  renderValue={(selected) => {
                    switch (selected) {
                      case "This Month":
                        return `${getMonthName(today)} 1-${new Date(
                          today.getFullYear(),
                          today.getMonth() + 1,
                          0
                        ).getDate()}`;
                      case "Last Month":
                        return `${formatDate(startDate)} - ${formatDate(
                          endDate
                        )}`;
                      case "Last 7 days":
                        return `${formatDate(
                          new Date(today.getTime() - 6 * 24 * 60 * 60 * 1000)
                        )} - ${formatDate(today)}`;
                      case "Last 30 days":
                        return `${formatDate(
                          new Date(today.getTime() - 29 * 24 * 60 * 60 * 1000)
                        )} - ${formatDate(today)}`;
                      case "Yesterday":
                        return formatDate(
                          new Date(today.getTime() - 1 * 24 * 60 * 60 * 1000)
                        );
                      case "Today":
                        return formatDate(new Date(today.getTime()));
                      default:
                        return selected;
                    }
                  }}
                  sx={{
                    maxWidth: 250,
                    minWidth: 250,
                    fontSize: 15,
                    marginTop: 1,
                    marginBottom: 1,
                    whiteSpace: "normal",
                    wordwrap: "break-word",
                    overflow: "hidden",
                  }}
                >
                  <MenuItem value="Today" sx={{ fontSize: 15 }}>
                    Today
                  </MenuItem>
                  <MenuItem value="Yesterday" sx={{ fontSize: 15 }}>
                    Yesterday
                  </MenuItem>
                  <MenuItem value="This Month" sx={{ fontSize: 15 }}>
                    This Month
                  </MenuItem>
                  <MenuItem value="Last Month" sx={{ fontSize: 15 }}>
                    Last Month
                  </MenuItem>
                  <MenuItem value="Last 7 days" sx={{ fontSize: 15 }}>
                    Last 7 days
                  </MenuItem>
                  <MenuItem value="Last 30 days" sx={{ fontSize: 15 }}>
                    Last 30 days
                  </MenuItem>
                  <MenuItem value="Custom" sx={{ fontSize: 15 }}>
                    Custom
                  </MenuItem>
                </Select>
                <Box>
                  {selectedOption === "Custom" && (
                    <Grid container spacing={1} alignItems="center">
                      <Grid item>
                        <Typography sx={{ fontSize: 15 }}>
                          Start Date:
                        </Typography>
                        <StyledDatePicker
                          selected={startDate}
                          onChange={handleStartDateChange}
                          maxDate={new Date()}
                        />
                      </Grid>
                      <Grid item>
                        <Typography sx={{ fontSize: 15 }}>End Date:</Typography>
                        <StyledDatePicker
                          selected={endDate}
                          onChange={handleEndDateChange}
                          minDate={startDate}
                          maxDate={new Date()}
                        />
                      </Grid>
                    </Grid>
                  )}
                </Box>
              </Grid>
              <Button
                style={{
                  backgroundColor: "#0160F1",
                  color: "white",
                  fontSize: "0.875rem",
                  borderRadius: "0.35rem",
                  marginLeft: "4rem",
                  marginTop: "1.5rem",
                  paddingLeft: "1rem",
                  paddingRight: "1rem",
                  padding: "0.5rem 1.125rem",
                }}
                onClick={() => {
                  handleFilterData();
                }}
              >
                Filter Data
              </Button>
            </Grid>
          </CardContent>
        </Card>
        <RaisedRequests request={"Created Requests"} data={tabledata} />
      </Box>
    </>
  );
};

export default Index;
